module.exports = __webpack_public_path__ + "static/media/capela-santo-aleixo.f7d136a4.webp";